import { Box, Grid } from '@material-ui/core';
import { ArticleType } from '@nemuru-eng/js-api-client';

import { CategorySelector } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/components/CategorySelector';
import { Font } from '@/components/shared/components/Font';
import { DateFormField } from '@/components/shared/components/NewContextForms/DateFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';

export const ServiceForm = () => {
  return (
    <Box width={'100%'}>
      <Font variant="h4" color="textPrimary">
        <Text strong tId={'SERVICE_DETAILS'} />
      </Font>
      <Box mt={2} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextFormField name={'item.description'} label={'SERVICE_DESCRIPTION'} fieldVariant={FieldVariant.form} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CategorySelector type={ArticleType.SERVICE} textIdSuffix="ARTICLE_SERVICE_CATEGORY" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DateFormField fieldVariant={FieldVariant.form} disablePast label={'SERVICE_ENDS_ON'} name={'item.endDate'} />
        </Grid>
      </Grid>
    </Box>
  );
};
